import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts"; // Import echarts directly
import { useTheme } from "@mui/material/styles"; // Import useTheme from MUI
import NoDataText from "../NoDataText/NoDataText";

const HorizontalBarChart = ({ data, sortConfig, encode, handleClick }) => {
	// Access the MUI theme
	const theme = useTheme();

	// Check if the data is empty
	if (!data || data.length === 0) {
		return <NoDataText />;
	}

	// Prepare the chart options
	const option = {
		dataset: [
			{
				dimensions: data[0].dimensions,
				source: data[0].source,
			},
			{
				transform: {
					type: "sort",
					config: { dimension: sortConfig.dimension, order: sortConfig.order },
				},
			},
		],
		tooltip: {
			trigger: "axis",
			axisPointer: {
				type: "shadow",
			},
		},
		legend: {
			orient: "horizontal",
			left: "center",
			// top: "top",
			bottom: "bottom",
		},
		grid: {
			left: "3%",
			right: "4%",
			bottom: "3%",
			containLabel: true,
		},
		xAxis: {
			type: "value",
		},
		yAxis: {
			type: "category",
			axisLabel: {
				interval: 0, // Ensure all labels are shown
				formatter: function (value) {
					// Truncate the text and add ellipsis if it exceeds a certain length
					const maxLength = 15; // Set your preferred character limit
					return value.length > maxLength ? value.substring(0, maxLength) + "..." : value;
				},
				width: 100, // Set a fixed width for the label
				overflow: "truncate", // Truncate overflow text
			},
		},
		series: {
			type: "bar",
			encode: encode,
			datasetIndex: 1,
			color: ["#5470C6", "#91CC75", "#FAC858", "#EE6666", "#73C0DE", "#3BA272", "#FC8452", "#9A60B4", "#EA7CCC"], // Add colors here
		},
	};

	return <ReactECharts option={option} style={{ height: "98%", width: "95%" }} onEvents={{ click: handleClick }} />;
};

export default HorizontalBarChart;
